import { PrivateURLConstants } from '@constants/private-url.constant';
import { Page, TestData } from '@testsigmainc/models';

import api from '../api/instance';

const nameSpace = PrivateURLConstants.TEST_DATA;
const importSpace = '/import';
const updateSpace = '/update';

export type findAllProps = {
  query: string;
  sort?: string;
  size?: number;
  page?: number;
};

const findAll = (
  query?: string,
  sort?: string,
  size?: number,
  page?: number,
  isListView?: boolean,
) => {
  return api
    .get(`${nameSpace}${isListView ? '/list' : ''}`, {
      query,
      size,
      sort,
      page,
    })
    .then((res) => new Page<TestData>().deserialize(res, TestData))
    .catch((e) => Promise.reject(e));
};

const show = (mailBoxId: number): Promise<TestData> => {
  return api
    .get(nameSpace + '/' + mailBoxId)
    .then((res) => new TestData().deserialize(res))
    .catch((e) => Promise.reject(e));
};

const bulkDeleted = (ids: number[], applicationVersionId: number) => {
  return api
    .remove(
      `${nameSpace}/bulk?${`ids[]`}=${ids.join()}&applicationVersionId=${applicationVersionId}`,
    )
    .then((res) => res)
    .catch((e) => Promise.reject(e));
};

const remove = (testDataId: number, applicationVersionId: number) => {
  return api.remove(
    nameSpace + `/${testDataId}?applicationVersionId=${applicationVersionId}`,
  );
};

const importFieldNames = (file: File, applicationVersionId: number) => {
  const formData: FormData = new FormData();
  formData.append('file', file);
  return api
    .put(
      `${nameSpace}/import_field_names?applicationVersionId=${applicationVersionId}`,
      formData,
      null,
      'multipart/form-data',
    )
    .then((res) => res)
    .catch((e) => {
      return Promise.reject(e);
    });
};
type ImportDataQuery = {
  versionId: number;
  name: string;
  testDataId?: number;
  passwords: string[];
};
const importData = (file: File, filterQuery: ImportDataQuery) => {
  const formData: FormData = new FormData();
  formData.append('file', file);
  const paramsString = `${'passwords[]'}=${filterQuery?.passwords?.join?.()}&name=${encodeURIComponent(
    filterQuery.name,
  )}&versionId=${filterQuery.versionId}${
    filterQuery?.testDataId ? `&testDataId=${filterQuery.testDataId}` : ''
  }`;
  return api
    .post(
      `${nameSpace}${importSpace}?${paramsString}`,
      formData,
      'multipart/form-data',
    )
    .then((res) => res)
    .catch((e) => {
      return Promise.reject(e);
    });
};

const updateData = (file: File, filterQuery: ImportDataQuery) => {
  const formData: FormData = new FormData();
  formData.append('file', file);
  const paramsString = `${'passwords[]'}=${filterQuery?.passwords?.join?.()}&name=${encodeURIComponent(
    filterQuery.name,
  )}&versionId=${filterQuery.versionId}${
    filterQuery?.testDataId ? `&testDataId=${filterQuery.testDataId}` : ''
  }`;
  return api
    .put(
      `${nameSpace}${updateSpace}?${paramsString}`,
      formData,
      null,
      'multipart/form-data',
    )
    .then((res) => res)
    .catch((e) => {
      return Promise.reject(e);
    });
};

const create = (testData: TestData) => {
  return api
    .post(nameSpace, testData)
    .then((res) => new TestData().deserialize(res))
    .catch((e) => Promise.reject(e));
};

const update = (testDataId: number, testData: TestData) => {
  return api
    .put(`${nameSpace}/${testDataId}`, testData)
    .then((res) => new TestData().deserialize(res))
    .catch((e) => Promise.reject(e));
};
const patchUpdate = (testDataId: number, testData: TestData) => {
  return api
    .patch(`${nameSpace}/${testDataId}`, testData)
    .then((res) => res)
    .catch((e) => Promise.reject(e));
};

const TestDataParameterService = {
  findAll,
  show,
  bulkDeleted,
  importFieldNames,
  remove,
  importData,
  updateData,
  create,
  update,
  patchUpdate,
};

export default TestDataParameterService;
